export enum PAGE_PARAM {
	NEW = "new",
	EDIT = "edit",
}

export enum DINING_TYPE {
	DINEIN = "dinein",
	TAKEAWAY = "takeaway",
}

export const CART_LEVEL_TAKEAWAY_BYOB_FEE = 0; // fee when BYOB is selected

export const LINK_PAY_SUCCESS_CODE = 200;

export enum LINKPAY_COOKIES {
	ACCESS_TOKEN = "access_token",
	UID = "uid",
	HAS_DEFAULT_CARD = "has_default_card",
}
